module.exports = __webpack_public_path__ + "static/img/yunyan-2.5ba9f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yunyan-2.png
// module id = XOS9
// module chunks = 1